import React from "react"
import styled from "styled-components"
import { Loader, LoaderTheme } from "components/atoms/Loader"

// @ts-ignore
import MojoLogo from "url:assets/images/mojo-logo.png"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: ${({ theme }) => theme.colors.neutral[0]};
`

const MojoLogoImage = styled.img`
  width: 160px;
  margin-bottom: 2rem;
`

const LoadingText = styled.p`
  color: ${({ theme }) => theme.colors.neutral[900]};
  font-size: 1.1rem;
  margin: 1.5rem 0 0 0;
  text-align: center;
`

export const AppLoadingSpinner: React.FC = () => (
  <Container>
    <MojoLogoImage src={MojoLogo} alt="Mojo" />
    <Loader size={50} theme={LoaderTheme.Outline} />
  </Container>
)